module.exports = __webpack_public_path__ + "static/pattern-design-02-65957b5f1b6413164ee62aa3bbf3c303.jpg";